"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreePropertyOptionsOverlayControlModule = /** @class */ (function () {
    function TreePropertyOptionsOverlayControlModule() {
    }
    return TreePropertyOptionsOverlayControlModule;
}());
exports.TreePropertyOptionsOverlayControlModule = TreePropertyOptionsOverlayControlModule;
